import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './sections/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MatomoTrackingService } from './services/matomo-tracking.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,FooterComponent,NavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
    constructor(private matomoTrackingService: MatomoTrackingService) {
    console.log('Matomo Tracking Service inicializado a través de AppComponent.');
}}
